export default __webpack_public_path__ + "b6b6ea337328db3571c79f030ac9e5e8.png";